module.exports = __webpack_public_path__ + "static/img/spirit-1.bca24e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/spirit-1.png
// module id = E2SW
// module chunks = 8